import { z } from "zod";
import { ValidationMethods } from "../utility/validationMethods";
export var resetPasswordFormSchema = z.object({
    password: z
        .string()
        .min(8, "Password must be at least 8 characters.")
        .refine(function (value) { return ValidationMethods.isNotEmoji(value); }, "Emoji characters are not allowed.")
        .refine(function (value) { return ValidationMethods.containsUppercaseLetter(value); }, "Password must include at least one uppercase letter.")
        .refine(function (value) { return ValidationMethods.containsDigit(value); }, "Password must include at least one number.")
        .refine(function (value) { return ValidationMethods.containsSpecialCharacter(value); }, "Password must include at least one special character.")
        .refine(function (value) { return ValidationMethods.isAsciiPrintableWithoutSpaces(value); }, "Password can only include standard letters, numbers, and symbols."),
    confirmPassword: z
        .string()
        .min(1, "Please confirm your password.")
        .refine(function (value) { return ValidationMethods.isNotEmoji(value); }, "Emoji characters are not allowed.")
        .refine(function (value) { return ValidationMethods.isAsciiPrintableWithoutSpaces(value); }, "Password can only include standard letters, numbers, and symbols."),
}).superRefine(function (value, ctx) {
    if (value.confirmPassword !== value.password) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["confirmPassword"],
            message: "Passwords must match.",
        });
    }
});
